<template>
  <div>
    <div>
      <v-flex>
        <v-text-field
          single-line
          prepend-inner-icon="search"
          clearable
          hide-details
          aria-label="Søk etter kart.."
          placeholder="Søk.."
          box
          v-model="searchValue"
        ></v-text-field>
      </v-flex>

      <v-list
        style="overflow-y: auto; "
        :class="[
          useInDialog
            ? $vuetify.breakpoint.smAndDown
              ? 'profiles-list-dialog-mobile'
              : 'profiles-list-dialog'
            : $vuetify.breakpoint.smAndDown
            ? 'profiles-list-fullscreen-mobile'
            : 'profiles-list-fullscreen'
        ]"
        two-line
      >
        <template v-for="(category, name) in categoriesSorted">
          <v-subheader
            v-show="
              (name !== 'Ukategorisert' || useInDialog) &&
                (searchValue == '' || searchValue == null) &&
                (selectedCategory == 'Alle' || selectedCategory == name)
            "
            :key="name"
            >{{ name }}</v-subheader
          >

          <template v-for="(card, key) in category">
            <v-hover :key="name + key">
              <v-list-tile
                v-show="
                  (name !== 'Ukategorisert' ||
                    (useInDialog && card.onlyAllowAddingFromDialog)) &&
                    (!card.hasOwnProperty('test') || card.test === false) &&
                    (!card.hasOwnProperty('internal') ||
                      card.internal === false ||
                      isConnectedToIntranet) &&
                    (selectedCategory == 'Alle' || selectedCategory == name) &&
                    (searchValue == '' ||
                      searchValue == null ||
                      showMapDuringSearch(name, card.title))
                "
                :key="name + key"
                :disabled="addedMapids.includes(key)"
                slot-scope="{ hover }"
                avatar
                @click="openProfile(key, card)"
              >
                <v-list-tile-avatar color="grey lighten-2">
                  <img :alt="'Bilde som representerer tema ' + card.title "
                    v-if="!card.isSavedOrSharedMap"
                    :src="
                      card.hasOwnProperty('smallImageUrl')
                        ? card.smallImageUrl
                        : getImgUrl(key)
                    "
                  />
                  <v-icon v-else>mdi-map</v-icon>
                </v-list-tile-avatar>

                <v-list-tile-content>
                  <v-list-tile-title>{{ card.title }}</v-list-tile-title>
                  <v-list-tile-sub-title
                    v-html="card.shortDescription"
                  ></v-list-tile-sub-title>
                </v-list-tile-content>

                <v-list-tile-action
                  v-if="
                    $vuetify.breakpoint.mdAndUp &&
                      hover &&
                      useInDialog === false
                  "
                >
                  <layer-favourite-toggler :layerId="key" />
                </v-list-tile-action>

                <v-list-tile-action
                  v-if="
                    showDownloadAction &&
                      $vuetify.breakpoint.mdAndUp &&
                      !card.isSavedOrSharedMap &&
                      hover
                  "
                >
                  <v-tooltip left>
                    <template v-slot:activator="{ on }">
                      <v-btn
                        v-on="on"
                        :href="getProfileDownloadUrl(key)"
                        @click.stop
                        icon
                        :disabled="!card.canBeDownloaded"
                      >
                        <v-icon>mdi-download-outline</v-icon>
                      </v-btn>
                    </template>
                    <span>Åpne temaet i NVE sin nedlastingsportal</span>
                  </v-tooltip>
                </v-list-tile-action>

                <v-list-tile-action v-if="$vuetify.breakpoint.mdAndUp">
                  <v-btn
                    v-if="openMapOnClick == false"
                    color="grey lighten-2"
                    @click="selectProfile(key, card)"
                    :disabled="addedMapids.includes(key)"
                    icon
                  >
                    <v-icon color="primary">add</v-icon>
                  </v-btn>
                </v-list-tile-action>
              </v-list-tile>
            </v-hover>
          </template>
        </template>
      </v-list>
    </div>
  </div>
</template>

<script>
import { mapState, mapActions } from "vuex";
import LayerFavouriteToggler from "@/components/LayerFavouriteToggler";
import MappingMixin from "@/mixins/mappingMixin";
import ProfilesMixin from "@/mixins/profilesMixin";
export default {
  data: () => ({
    dialog: false,
    searchValue: "",
    savedAndSharedMaps: {}
  }),
  mixins: [MappingMixin, ProfilesMixin],
  props: {
    openMapOnClick: Boolean,
    showDownloadAction: Boolean,
    useInDialog: Boolean,
    selectedCategory: String
  },
  watch: {
    favourites() {
      this.getCategoriesSorted();
    },
    profiles() {
      this.getCategoriesSorted();
    },
    savedAndSharedMaps() {
      this.getCategoriesSorted();
    },
    isConnectedToIntranet() {
      this.getCategoriesSorted();
    }
  },
  components: { LayerFavouriteToggler },
  methods: {
    ...mapActions([
      "setSnack",
      "setSelectedMapProfile",
      "addGraphicsLayer",
      "activateTool",
      "initStore",
      "setExplorerVisible"
    ]),
    openProfile(key, map) {
      if (this.useInDialog) {
        this.selectProfile(key, map);
      } else {
        if (map.isSavedOrSharedMap) {
          //   this.$router.push("/prosjekt/" + key + "/" + map.hash);
          let routeData = this.$router.resolve({
            name: "prosjekt",
            params: { projectId: key, editHash: map.hash }
          });
          window.open(routeData.href, "_self");
        } else {
          let routeData = this.$router.resolve({
            name: "tema",
            params: { id: key }
          });
          window.open(routeData.href, "_self");
          //   this.$router.push("/tema/" + key);
        }
      }
    },
    getProfileDownloadUrl(id) {
      return process.env.VUE_APP_DOWNLOAD_MAP_DATA_SERVICE_URL + id + "&";
    },
    getImgUrl(id) {
      try {
        return require("../assets/small/" + id + ".jpg");
      } catch (e) {
        require("../assets/small/" + "placeholder" + ".jpg");
      }
    },
    selectProfile: function(name, item) {
      if (item && this.mapLoaded) {
        if (item.hasOwnProperty("graphics")) {
          this.addMapProfile(item);
        } else {
          this.addMapProfile({
            id: name,
            type: item.type,
            showInfoMenu: this.sidebarHasOpened ? false : true
          });

          this.$emit("profile-added");
        }
      }
    },
    showMapDuringSearch: function(categoryName, title) {
      if (categoryName === "Favoritter") {
        return false;
      }
      return title.toLowerCase().includes(this.searchValue.toLocaleLowerCase());
    }
  },
  mounted() {
    this.initStore();
    this.lastVisitedMaps.forEach(lastVisitedMap => {
      this.savedAndSharedMaps[lastVisitedMap.id] = {
        title: lastVisitedMap.title,
        hash: lastVisitedMap.hash,
        isSavedOrSharedMap: true
      };
    });
  },
  computed: {
    ...mapState([
      "mapLoaded",
      "sidebarHasOpened",
      "lastVisitedMaps",
      "favourites"
    ]),
    explorerVisible: {
      set(explorerVisible) {
        this.setExplorerVisible(explorerVisible);
      },
      get() {
        return this.$store.state.explorerVisible;
      }
    },
    favouriteCategory() {
      let favouriteCategory = {};
      for (let category in this.categories) {
        for (let profile in category) {
          if (this.favourites.includes(profile.id)) {
            favouriteCategory[profile.id] = profile;
          }
        }
      }
      return favouriteCategory;
    },
    addedMapids() {
      let addedMapids = [];
      for (let i = 0; i < this.mapProfiles.length; i++) {
        addedMapids.push(this.mapProfiles[i].id);
      }
      return addedMapids;
    }
  }
};
</script>

<style>
.profiles-list-dialog {
  max-height: calc(100vh - 400px);
  min-height: calc(100vh - 400px);
}
.profiles-list-dialog-mobile {
  max-height: calc(100vh - 250px);
}
.profiles-list-fullscreen {
  max-height: calc(100vh - 61px);
}

.profiles-list-fullscreen-mobile {
  max-height: calc(100vh - 109px);
}
</style>
